document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#MainNav');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const button = section.querySelector('[data-add-to-cart]');
    const variantsElement = section.parentElement.querySelector('[data-product-json]');

    if (!select || !variantInput || !variantsElement) return;

    const variants = JSON.parse(variantsElement.textContent);
    const moneyFormat = (amount) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(amount / 100);

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;

      variantInput.value = variant.id;

      if (price) {
        const compareAt = variant.compare_at_price > variant.price
          ? `<s>${moneyFormat(variant.compare_at_price)}</s>`
          : '';
        price.innerHTML = `<span>${moneyFormat(variant.price)}</span>${compareAt}`;
      }

      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });
});
